import { render, staticRenderFns } from "./RequestPage.vue?vue&type=template&id=3b6cfc07&scoped=true"
import script from "./RequestPage.vue?vue&type=script&lang=js"
export * from "./RequestPage.vue?vue&type=script&lang=js"
import style0 from "./RequestPage.vue?vue&type=style&index=0&id=3b6cfc07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6cfc07",
  null
  
)

export default component.exports